import React, { useState, useEffect } from 'react';
import { InputGroup, InputGroupAddon, InputGroupText, Input, Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { loginUser, sendVerification } from '../actions/formActions';
import { Redirect, useHistory } from 'react-router-dom';
import { resetSyncCart } from '../actions/shoppingCart';
import { removeGuestReducer } from '../actions/guestActions';
import { Helmet } from 'react-helmet';
import Spinner from './Spinner';

const Login = (props: any) => {
  const { auth, errors: propsErrors, cart } = props;
  const history = useHistory();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<any>({});

  const onChange = (e) => {
    if (e.target.name === 'email') setEmail(e.target.value);
    if (e.target.name === 'password') setPassword(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const userData: any = {
      email,
      password,
    };

    userData.cart = [...cart.cart];

    if (!cart.syncCart) {
      userData.sync = false;
    } else {
      userData.sync = true;
    }

    props.loginUser(userData);
  };

  const prevAuthRef = React.useRef(auth.isAuthenticated);
  const prevErrorsRef = React.useRef(propsErrors);

  useEffect(() => {
    if (auth.isAuthenticated !== prevAuthRef.current) {
      prevAuthRef.current = auth.isAuthenticated;
      props.resetSyncCart();
      props.removeGuestReducer();
      if (auth.user.isAdmin) {
        history.push('/adminpanel');
      } else {
        history.push('/dashboard');
      }
    }
  });

  useEffect(() => {
    if (propsErrors !== prevErrorsRef.current) {
      prevErrorsRef.current = propsErrors;
      setErrors(propsErrors);
    }
  });

  const sendVerificationHandler = () => {
    let data: any = {};
    data.email = email;
    if (email !== '') {
      props.sendVerification(data);
    }
  };

  if (localStorage.jwtToken) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <div className="container my-5 py-5" style={{ minHeight: '50vh' }}>
      <div>
        <Helmet>
          <title>Login - Frozberries Victoria</title>
          <meta name="description" content="Login - Frozberries Victoria" />
        </Helmet>
      </div>
      <div className="row">
        <div className="col-md-8 m-auto">
          <h1 className="display-4 text-center mb-5">Log In</h1>

          {errors.verify && (
            <Alert color="danger">
              Please verify your email. Click{' '}
              <span
                onClick={sendVerificationHandler}
                style={{ cursor: 'pointer', color: 'cornflowerblue' }}
              >
                here
              </span>{' '}
              to receive another verification link.
            </Alert>
          )}
          {auth.resendLink && <Alert color="success">Verification link has been resent.</Alert>}

          <form onSubmit={onSubmit}>
            <InputGroup className="my-2">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>@</InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="email"
                onChange={onChange}
                className={classnames('', { 'is-invalid': errors.email })}
                value={email}
                name="email"
              />
              <div className="invalid-feedback">{errors.email}</div>
            </InputGroup>

            <InputGroup className="my-2">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>@</InputGroupText>
              </InputGroupAddon>
              <Input
                type="password"
                placeholder="password"
                onChange={onChange}
                className={classnames('', { 'is-invalid': errors.password })}
                value={password}
                name="password"
                autoComplete="on"
              />
              <div className="invalid-feedback">{errors.password}</div>
            </InputGroup>

            <small className="float-left pb-2">
              Not a member? <Link to="/signup">Sign Up</Link>
            </small>
            <small className="float-right pb-2">
              <Link to="/reset-password">Forgot password?</Link>
            </small>
            {auth.spinner && (
              <div className="text-center">
                <Spinner />
              </div>
            )}
            <input
              disabled={email === '' || password === '' ? true : false}
              type="submit"
              value={auth.spinner ? 'Please Wait..' : 'Login'}
              className=" text-light btn-block mt-4 p-2 border-0"
              style={{ backgroundColor: 'rgb(236,23,79)' }}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  errors: state.errors,
  auth: state.form,
  cart: state.cart,
});

export default connect(mapStateToProps, {
  loginUser,
  resetSyncCart,
  removeGuestReducer,
  sendVerification,
})(Login);
